import { useTranslation } from "react-i18next";

const SheepMenu = () => {
  const { t } = useTranslation();

  return (
    <div class="vc_tta-panels-container">
      <div class="vc_tta-panels">
        <div
          class="vc_tta-panel vc_active"
          id="1501871514474-98fac6cb-b327"
          data-vc-content=".vc_tta-panel-body"
        >
          <div class="vc_tta-panel-body">
            <div class="mgt-header-block clearfix text-center text-black wpb_animate_when_almost_visible wpb_fadeInUp fadeInUp wpb_content_element mgt-header-block-style-2 mgt-header-block-fontsize-regular mgt-header-texttransform-none mgt-header-block-42722978">
              <h2 class="mgt-header-block-title text-font-weight-default">
                {t("menuPage.sheepMenu.title")}
              </h2>
              <div class="mgt-header-line mgt-header-line-margin-small"></div>
            </div>
            <div class="wpb_text_column wpb_content_element wpb_animate_when_almost_visible wpb_fadeInUp fadeInUp vc_custom_1501952538196 text-size-medium">
              <div class="wpb_wrapper" style={{ textAlign: "center" }}>
                <p style={{ textAlign: "center" }}>
                  <span style={{ color: "#999999" }}>
                    <em>{t("menuPage.sheepMenu.subTitle1")}</em>
                  </span>
                </p>
                <p style={{ textAlign: "center" }}>
                  <span style={{ color: "#999999" }}>
                    <em>{t("menuPage.sheepMenu.subTitle2")}</em>
                  </span>
                </p>
                <p style={{ textAlign: "center" }}>
                  <span style={{ color: "#999999" }}>
                    <em>{t("menuPage.sheepMenu.subTitle3")}</em>
                  </span>
                </p>
              </div>
            </div>
            <div class="vc_row wpb_row vc_inner vc_row-fluid">
              <div class="wpb_column vc_column_container vc_col-sm-12">
                <div class="vc_column-inner">
                  <div class="wpb_wrapper" style={{ textAlign: "center" }}>
                    <div class="mgt-header-block clearfix text-left text-black wpb_animate_when_almost_visible wpb_fadeInLeft fadeInLeft wpb_content_element mgt-header-block-style-2 mgt-header-block-fontsize-regular mgt-header-texttransform-header mgt-header-block-60691344">
                      <h2
                        class="mgt-header-block-title text-font-weight-default"
                        style={{ textAlign: "center" }}
                      >
                        {t("menuPage.sheepMenu.menuName")}
                      </h2>
                    </div>
                    <div class="vc_separator wpb_content_element vc_separator_align_center vc_sep_width_100 vc_sep_border_width_3 vc_sep_pos_align_center vc_separator_no_text vc_sep_color_black wpb_animate_when_almost_visible wpb_fadeInLeft fadeInLeft wpb_animate_when_almost_visible wpb_fadeInLeft fadeInLeft">
                      <span class="vc_sep_holder vc_sep_holder_l">
                        <span class="vc_sep_line"></span>
                      </span>
                      <span class="vc_sep_holder vc_sep_holder_r">
                        <span class="vc_sep_line"></span>
                      </span>
                    </div>
                    <div class="mgt-item-price mgt-item-price-badge-color-red clearfix wpb_content_element wpb_animate_when_almost_visible wpb_fadeInUp fadeInUp">
                      <div class="mgt-item-price-details">
                        <h4>
                          <b>{t("menuPage.sheepMenu.meal1")} </b>
                          <span
                            style={{
                              fontSize: 18,
                              fontFamily: "cabin",
                            }}
                          >
                            - 4460 Ft
                          </span>
                        </h4>
                      </div>
                    </div>
                    <div class="mgt-item-price mgt-item-price-badge-color-orange clearfix wpb_content_element wpb_animate_when_almost_visible wpb_fadeInUp fadeInUp">
                      <div class="mgt-item-price-details">
                        <h4>
                          <b>{t("menuPage.sheepMenu.meal2")} </b>
                          <span
                            style={{
                              fontSize: 18,
                              fontFamily: "cabin",
                            }}
                          >
                            - 3560 Ft (2490 Ft)
                          </span>
                        </h4>
                      </div>
                    </div>
                    <div class="mgt-item-price mgt-item-price-badge-color-red clearfix wpb_content_element wpb_animate_when_almost_visible wpb_fadeInUp fadeInUp">
                      <div class="mgt-item-price-details">
                        <h4>
                          <b>{t("menuPage.sheepMenu.meal3")} </b>
                          <span
                            style={{
                              fontSize: 18,
                              fontFamily: "cabin",
                            }}
                          >
                            - 6460 Ft
                          </span>
                        </h4>
                      </div>
                    </div>
                    <div class="mgt-item-price mgt-item-price-badge-color-red clearfix wpb_content_element wpb_animate_when_almost_visible wpb_fadeInUp fadeInUp">
                      <div class="mgt-item-price-details">
                        <h4>
                          <b>{t("menuPage.sheepMenu.meal4")} </b>
                          <span
                            style={{
                              fontSize: 18,
                              fontFamily: "cabin",
                            }}
                          >
                            - 8640 Ft
                          </span>
                        </h4>
                      </div>
                    </div>
                    <div class="mgt-item-price mgt-item-price-badge-color-red clearfix wpb_content_element wpb_animate_when_almost_visible wpb_fadeInUp fadeInUp">
                      <div class="mgt-item-price-details">
                        <h4>
                          <b>{t("menuPage.sheepMenu.meal5")} </b>
                          <span
                            style={{
                              fontSize: 18,
                              fontFamily: "cabin",
                            }}
                          >
                            - 5480 Ft (3860 Ft)
                          </span>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="wpb_text_column wpb_content_element wpb_animate_when_almost_visible wpb_fadeInUp fadeInUp vc_custom_1501952538196 text-size-medium"
              style={{ border: "2px solid #c69f7c" }}
            >
              <div
                class="wpb_wrapper"
                style={{ textAlign: "center", paddingBottom: "20px" }}
              >
                <p style={{ textAlign: "center" }}>
                  <span style={{ color: "#999999" }}>
                    <em>{t("menuPage.sheepMenu.additionalText1")}</em>
                  </span>
                </p>
                <p style={{ textAlign: "center" }}>
                  <span style={{ color: "#999999" }}>
                    <em>{t("menuPage.sheepMenu.additionalText2")}</em>
                  </span>
                </p>
                <p style={{ textAlign: "center" }}>
                  <span style={{ color: "#999999" }}>
                    <em>{t("menuPage.sheepMenu.additionalText3")}</em>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SheepMenu;
